import React, { useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { Alignment, Fit, Layout, useRive, useStateMachineInput } from '@rive-app/react-canvas'
import { ClockContext } from 'contexts/TimerAppContexts/ClockContext.js'

import Clock from './Clock'
import ButtonClock from './ButtonClock'
import PomodoroBalls from './PomodoroBalls'

import 'stylesheets/TimerAppStyles/Timer.css'
import { AppContext } from 'contexts/TimerAppContexts/AppContext.js'

const Timer = () => {
    const SKY_INPUT_NAME = "Control"
    const SKY_STATE_MACHINE_NAME = "State Machine 1"

    const PLANT_INPUT_NAME = "GrowControl"
    const PLANT_STATE_MACHINE_NAME = "GrowMachine"

    const { rive: skyRive, RiveComponent: SkyAnimation } = useRive({
        src: `${process.env.PUBLIC_URL}/animation-sky-light.riv`,
        animations: "sun-rotation",
        autoplay: true,
        stateMachines: SKY_STATE_MACHINE_NAME,
    });

    const { rive: plantRive, RiveComponent: PlantAnimation } = useRive({
        src: `${process.env.PUBLIC_URL}/plant.riv`,
        autoplay: true,
        artboard: "Tallo",
        stateMachines: PLANT_STATE_MACHINE_NAME,
        Layout: new Layout({
            fit: Fit.Height,
            alignment: Alignment.Center,
        }),
    });

    const growControlInput = useStateMachineInput(
        plantRive,
        PLANT_STATE_MACHINE_NAME,
        PLANT_INPUT_NAME,
    )

    const numberInput = useStateMachineInput(
        skyRive,
        SKY_STATE_MACHINE_NAME,
        SKY_INPUT_NAME,
    )


    const {
        animationValue,
        breakMode,
        plantAnimationValue
    } = useContext(ClockContext);


    const {
        setOpenTimerModal,
        timerName,
    } = useContext(AppContext)

    useEffect(() => {
        if (numberInput !== null) {
            numberInput.value = animationValue;
            numberInput.fire();
        }
    }, [animationValue, numberInput])

    useEffect(() => {
        if (growControlInput !== null) {
            growControlInput.value = plantAnimationValue
            growControlInput.fire()
        }
    }, [plantAnimationValue, growControlInput])

    const handleCloseClick = () => {
        if (window.confirm("Do you really want to leave? You will lose your progress")){
            setOpenTimerModal(false)
        }
    }

    return (
        <div className='timer-main-container'>
            <div className={`timer-container ${breakMode ? 'break-mode' : ''}`}>
                <div className='timer-section-1'>
                    <FontAwesomeIcon onClick={handleCloseClick} icon={faXmark} className={`close-icon ${breakMode ? 'break-mode' : ''}`} />
                    <div className='timer-header'>
                        <p className={`timer-title ${breakMode ? 'break-mode' : ''}`}>{timerName}</p>
                    </div>

                    <Clock seconds={3} />
                </div>
                <div className='timer-section-2'>
                    <div className='space-container'>
                        <SkyAnimation />
                    </div>
                    <div className='plant-container'>
                        <PlantAnimation />
                        {/* <BabyPlant /> */}
                    </div>
                </div>
                <div className='timer-section-3'>
                    <PomodoroBalls />
                    <ButtonClock />
                </div>
            </div>
        </div>
    )
}

export { Timer }



    // <input id='number_input' min={0} max={200} type='number' onChange={(e)=>{
    //     const newValue = e.target.value;
    //     numberInput.value = newValue;
    //     numberInput.fire();
    // }}/>